export const INITIALIZE = 'INITIALIZE'
export const UPDATE_CONFIGS = 'UPDATE_CONFIGS'
export const FOCUS_INPUT = 'FOCUS_INPUT'
export const BLUR_INPUT = 'BLUR_INPUT'
export const CLEAR_INPUT = 'CLEAR_INPUT'
export const SELECT_RESULT = 'SELECT_RESULT'
export const SEARCH_BEGIN = 'SEARCH_BEGIN'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_FAILURE = 'SEARCH_FAILURE'
export const SET_RESULT_TYPE = 'SET_RESULT_TYPE'
export const CLOSE_RESULTS = 'CLOSE_RESULTS'
